<template>
  <section>
    <div
      class="fixed flex justify-center items-center w-full mt-4 z-40"
      v-show="success"
    >
      <div
        class="relative py-3 pl-4 pr-10 leading-normal md:w-6/12 bg-green-100 rounded-md border-l-8 border-green-light ring-1"
        role="alert"
      >
        <div>
          <span
            class="absolute inset-y-0 left-0 flex items-center ml-4 text-green-light"
          >
            <Tick />
          </span>
        </div>
        <div class="ml-10">
          <p class="font-bold text-gray-dark">Success</p>
          <p class="text-gray-light">
            {{ success }}
          </p>
          <button
            type="button"
            class="absolute inset-y-0 right-0 flex items-center mr-4 text-gray-light"
            @click="handleSuccessClose"
          >
            <svg class="w-4 h-4 fill-current" role="button" viewBox="0 0 20 20">
              <path
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clip-rule="evenodd"
                fill-rule="evenodd"
              ></path>
            </svg>
          </button>
        </div>
      </div>
    </div>

    <div
      class="fixed flex justify-center items-center w-full mt-4 z-40"
      v-show="error.title || error.text"
    >
      <div
        class="relative py-3 pl-4 pr-10 leading-normal w-6/12 bg-red-100 rounded-md border-l-8 border-red-500 ring-1"
        role="alert"
      >
        <div>
          <button
            type="button"
            class="absolute inset-y-0 left-0 flex items-center ml-4 text-red-500"
            @click="handleErrorClose"
          >
            <Cross />
          </button>
        </div>
        <div class="ml-10">
          <p class="font-bold text-gray-dark">
            Error:
            <span class="font-medium text-gray-light">{{ error.text }}</span>
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Tick from "@/components/icons/Tick.vue";
import Cross from "@/components/icons/Cross.vue";

export default {
  name: "Alerts",
  components: {
    Tick,
    Cross,
  },
  props: {
    success: {
      type: String,
      default: "",
    },
    error: {
      type: [Object, String],
    },
  },
  data() {
    return {};
  },
  watch: {
    success() {
      setTimeout(() => this.$store.commit("setIsSuccess", ""), 3000);
    },
    error() {
      setTimeout(() => this.$store.commit("setError", ""), 3000);
    },
  },
  methods: {
    handleSuccessClose() {
      this.$store.commit("setIsSuccess", "");
    },

    handleErrorClose() {
      this.$store.commit("setError", this.setErrorFalse());
    },

    setErrorFalse() {
      this.error.title = "";
      this.error.text = "";
      return this.error;
    },
  },
};
</script>